import { StaffScreen } from '../features/admins/StaffScreen'
import { useShell } from '../app/outlet'

export function StaffPage() {
  const { toast } = useShell()
  return <StaffScreen onToast={toast} />
}
